function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M13.2 14.4c0 1.06-.46 2.02-1.2 2.68-.64.58-1.48.92-2.4.92a3.598 3.598 0 01-.95-7.07A3.61 3.61 0 0012 13.21c.33 0 .65-.04.95-.13.16.4.25.85.25 1.32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 9.6c0 .47-.09.92-.25 1.33A3.61 3.61 0 0112 13.21c-.33 0-.65-.04-.95-.13A3.587 3.587 0 018.4 9.6C8.4 7.61 10.01 6 12 6s3.6 1.61 3.6 3.6z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M18 14.4a3.598 3.598 0 01-6 2.68 3.55 3.55 0 001.2-2.68c0-.47-.09-.92-.25-1.33 1.1-.3 1.99-1.1 2.4-2.15A3.62 3.62 0 0118 14.4z"
})));